import { loadLeaflet } from "@/features/constractors/drawers/ServiceCenterDrawer/loadLeaflet";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

export interface MarkerClusterGroup {
  addLayer(layer: unknown): MarkerClusterGroup;
  addLayers(layers: unknown[]): MarkerClusterGroup;
  removeLayer(layer: unknown): MarkerClusterGroup;
  clearLayers(): MarkerClusterGroup;
  getBounds(): { isValid(): boolean };
  addTo(map: unknown): MarkerClusterGroup;
  remove(): void;
  on(event: string, handler: (event: { layer: unknown }) => void): MarkerClusterGroup;
}

export interface LeafletTileLayer {
  addTo(map: unknown): LeafletTileLayer;
}

export interface LeafletWithClusterLib {
  map(container: HTMLElement, options: Record<string, unknown>): unknown;
  tileLayer(url: string, options: Record<string, unknown>): LeafletTileLayer;
  marker(latlng: [number, number], options?: Record<string, unknown>): unknown;
  latLngBounds(latlngs: Array<[number, number]>): unknown;
  divIcon(options: Record<string, unknown>): unknown;
  markerClusterGroup(options?: Record<string, unknown>): MarkerClusterGroup;
}

let clusterLoadPromise: Promise<LeafletWithClusterLib> | undefined;

export function loadLeafletCluster(): Promise<LeafletWithClusterLib> {
  if (clusterLoadPromise) return clusterLoadPromise;

  clusterLoadPromise = loadLeaflet()
    .then(async (lib) => {
      const L = lib as LeafletWithClusterLib;
      if (typeof L.markerClusterGroup !== "function") {
        await import("leaflet.markercluster");
      }
      const withCluster = (window as Window & { L?: LeafletWithClusterLib }).L;
      if (!withCluster?.markerClusterGroup) {
        throw new Error("Leaflet MarkerCluster failed to load");
      }
      return withCluster;
    })
    .catch((error) => {
      clusterLoadPromise = undefined;
      throw error;
    });

  return clusterLoadPromise;
}
